import { defineMessages } from 'react-intl';

export default defineMessages({
  yes: {
    id: 'app.components.ChipBoolean.yes',
    defaultMessage: 'Sim',
  },
  no: {
    id: 'app.components.ChipBoolean.no',
    defaultMessage: 'Não',
  },
  invalid: {
    id: 'app.components.ChipBoolean.invalid',
    defaultMessage: 'Item obrigatório',
  },
  AREA_DE_SERVICO: {
    id: 'app.components.ChipBoolean.AREA_DE_SERVICO',
    defaultMessage: 'Possui área de serviço',
  },
  AREA_VERDE: {
    id: 'app.components.ChipBoolean.AREA_VERDE',
    defaultMessage: 'Área verde',
  },
  ARMARIOS_EMBUTIDOS_NO_QUARTO: {
    id: 'app.components.ChipBoolean.ARMARIOS_EMBUTIDOS_NO_QUARTO',
    defaultMessage: 'Armário',
  },
  ARMARIOS_NA_COZINHA: {
    id: 'app.components.ChipBoolean.ARMARIOS_NA_COZINHA',
    defaultMessage: 'Armário',
  },
  AR_CONDICIONADO: {
    id: 'app.components.ChipBoolean.AR_CONDICIONADO',
    defaultMessage: 'Ar condicionado',
  },
  BANHEIRA_DE_HIDROMASSAGEM: {
    id: 'app.components.ChipBoolean.BANHEIRA_DE_HIDROMASSAGEM',
    defaultMessage: 'Banheira',
  },
  BANHEIRO_ADAPTADO: {
    id: 'app.components.ChipBoolean.BANHEIRO_ADAPTADO',
    defaultMessage: 'Banheiro adaptado com barras de apoio',
  },
  BRINQUEDOTECA: {
    id: 'app.components.ChipBoolean.BRINQUEDOTECA',
    defaultMessage: 'Brinquedoteca',
  },
  CAMA_DE_CASAL: {
    id: 'app.components.ChipBoolean.CAMA_DE_CASAL',
    defaultMessage: 'Cama de casal',
  },
  CAMA_DE_SOLTEIRO: {
    id: 'app.components.ChipBoolean.CAMA_DE_SOLTEIRO',
    defaultMessage: 'Cama de solteiro',
  },
  CHUVEIRO_A_GAS: {
    id: 'app.components.ChipBoolean.CHUVEIRO_A_GAS',
    defaultMessage: 'Chuveiro à gás',
  },
  CLOSET: {
    id: 'app.components.ChipBoolean.CLOSET',
    defaultMessage: 'Closet',
  },
  COOKTOP: {
    id: 'app.components.ChipBoolean.COOKTOP',
    defaultMessage: 'Cooktop',
  },
  CORRIMAO: {
    id: 'app.components.ChipBoolean.CORRIMAO',
    defaultMessage: 'Corrimão',
  },
  COZINHA_AMERICANA: {
    id: 'app.components.ChipBoolean.COZINHA_AMERICANA',
    defaultMessage: 'Cozinha americana',
  },
  FOGAO_INCLUSO: {
    id: 'app.components.ChipBoolean.FOGAO_INCLUSO',
    defaultMessage: 'Fogão',
  },
  GELADEIRA_INCLUSO: {
    id: 'app.components.ChipBoolean.GELADEIRA_INCLUSO',
    defaultMessage: 'Geladeira',
  },
  JARDIM: {
    id: 'app.components.ChipBoolean.JARDIM',
    defaultMessage: 'Jardim',
  },
  LAVANDERIA_NO_PREDIO: {
    id: 'app.components.ChipBoolean.LAVANDERIA_NO_PREDIO',
    defaultMessage: 'Lavanderia',
  },
  LUMINOSIDADE_NATURAL: {
    id: 'app.components.ChipBoolean.LUMINOSIDADE_NATURAL',
    defaultMessage: '  Janela grande',
  },
  MAQUINA_DE_LAVAR: {
    id: 'app.components.ChipBoolean.MAQUINA_DE_LAVAR',
    defaultMessage: 'Máquina de lavar',
  },
  MESAS_E_CADEIRAS_DE_ESCRITORIO: {
    id: 'app.components.ChipBoolean.MESAS_E_CADEIRAS_DE_ESCRITORIO',
    defaultMessage: 'Mesa ou cadeira de escritório',
  },
  MESAS_E_CADEIRAS_DE_JANTAR: {
    id: 'app.components.ChipBoolean.MESAS_E_CADEIRAS_DE_JANTAR',
    defaultMessage: 'Mesas e cadeiras de jantar',
  },
  MICROONDAS: {
    id: 'app.components.ChipBoolean.MICROONDAS',
    defaultMessage: 'Micro-ondas',
  },
  PISO_TATIL: {
    id: 'app.components.ChipBoolean.PISO_TATIL',
    defaultMessage: 'Piso tátil',
  },
  PLAYGROUND: {
    id: 'app.components.ChipBoolean.PLAYGROUND',
    defaultMessage: 'Playground',
  },
  QUADRA_ESPORTIVA: {
    id: 'app.components.ChipBoolean.QUADRA_ESPORTIVA',
    defaultMessage: 'Quadra poliesportiva',
  },
  QUARTOS_E_CORREDORES_COM_PORTAS_AMPLAS: {
    id: 'app.components.ChipBoolean.QUARTOS_E_CORREDORES_COM_PORTAS_AMPLAS',
    defaultMessage: 'Portas e corredores com largura mínima de 0,80 m',
  },
  RAMPAS_DE_ACESSO: {
    id: 'app.components.ChipBoolean.RAMPAS_DE_ACESSO',
    defaultMessage: 'Rampas de acesso',
  },
  RUA_SILENCIOSA: {
    id: 'app.components.ChipBoolean.RUA_SILENCIOSA',
    defaultMessage: 'Rua silenciosa',
  },
  SALAO_DE_JOGOS: {
    id: 'app.components.ChipBoolean.SALAO_DE_JOGOS',
    defaultMessage: 'Espaço de jogos',
  },
  SALAO_DE_FESTAS: {
    id: 'app.components.ChipBoolean.SALAO_DE_FESTAS',
    defaultMessage: 'Salão de festas',
  },
  SOMENTE_UMA_CASA_NO_TERRENO: {
    id: 'app.components.ChipBoolean.SOMENTE_UMA_CASA_NO_TERRENO',
    defaultMessage: 'Somente uma casa no terreno',
  },
  TANQUE: {
    id: 'app.components.ChipBoolean.TANQUE',
    defaultMessage: 'Tanque',
  },
  UTENSILIOS_DE_COZINHA: {
    id: 'app.components.ChipBoolean.UTENSILIOS_DE_COZINHA',
    defaultMessage: 'Utensílios',
  },
  VAGA_DE_GARAGEM_ACESSIVEL: {
    id: 'app.components.ChipBoolean.VAGA_DE_GARAGEM_ACESSIVEL',
    defaultMessage: 'Vaga de garagem com espaço de circulação de no mínimo 1,2 m',
  },
  VARANDA: {
    id: 'app.components.ChipBoolean.VARANDA',
    defaultMessage: 'Varanda',
  },
  VENTILADOR_DE_TETO: {
    id: 'app.components.ChipBoolean.VENTILADOR_DE_TETO',
    defaultMessage: 'Ventilador de teto',
  },
  elevador: {
    id: 'app.components.ChipBoolean.elevador',
    defaultMessage: 'Elevador',
  },
  ACADEMIA: {
    id: 'app.components.ChipBoolean.ACADEMIA',
    defaultMessage: 'Academia',
  },
  APARTAMENTO_COBERTURA: {
    id: 'app.components.ChipBoolean.APARTAMENTO_COBERTURA',
    defaultMessage: 'Apartamento cobertura',
  },
  BOX: {
    id: 'app.components.ChipBoolean.BOX',
    defaultMessage: 'Box',
  },
  CHURRASQUEIRA: {
    id: 'app.components.ChipBoolean.CHURRASQUEIRA',
    defaultMessage: 'Churrasqueira',
  },
  PISCINA: {
    id: 'app.components.ChipBoolean.PISCINA',
    defaultMessage: 'Piscina',
  },
  SAUNA: {
    id: 'app.components.ChipBoolean.SAUNA',
    defaultMessage: 'Sauna',
  },
  SOFA: {
    id: 'app.components.ChipBoolean.SOFA',
    defaultMessage: 'Sofá',
  },
  SOL_DA_MANHA: {
    id: 'app.components.ChipBoolean.SOL_DA_MANHA',
    defaultMessage: 'Sol da manhã',
  },
  SOL_DA_TARDE: {
    id: 'app.components.ChipBoolean.SOL_DA_TARDE',
    defaultMessage: 'Sol da tarde',
  },
  TELEVISAO: {
    id: 'app.components.ChipBoolean.TELEVISAO',
    defaultMessage: 'Televisão',
  },
  ARMARIOS_NOS_BANHEIROS: {
    id: 'app.components.ChipBoolean.ARMARIOS_NOS_BANHEIROS',
    defaultMessage: 'Armário',
  },
  QUINTAL: {
    id: 'app.components.ChipBoolean.QUINTAL',
    defaultMessage: 'Quintal',
  },
  VISTA_LIVRE: {
    id: 'app.components.ChipBoolean.VISTA_LIVRE',
    defaultMessage: 'Vista livre',
  },
  GARDEN: {
    id: 'app.components.ChipBoolean.GARDEN',
    defaultMessage: 'Garden/Área privativa',
  },
});
